// extracted by mini-css-extract-plugin
export default {"item":"DraggableSwitchItem_item__Iaqqu","itemName":"DraggableSwitchItem_itemName__0Qbss"};